export var reqIdHistoryMapper = function (data) {
    var result = [];
    if (data && data.lst) {
        result = data.lst.map(function (item) {
            return {
                authStatus: item.authSts,
                updateStatus: item.updSts,
                isin: item.isin,
                subRequestId: item.subReqId,
                symbolName: item.symNm,
                quantity: item.qty,
            };
        });
    }
    return result;
};
